import React from "react";
import moment from "moment";
import "./css/MentorApplicationView.scss";

const renderList = (items, prefix = "") =>
  (Array.isArray(items) ? items : []).map((elem) => (
    <div key={elem}>
      {prefix}
      {elem}
    </div>
  ));

function NewMentorAppInfo({ info }) {
  return (
    <div className="info-container">
      <div className="single-info-section info2" style={{ marginTop: "0em" }}>
        <div className="answer">
          {info.date_submitted &&
            `Submission Date: ${moment(info.date_submitted.$date).format(
              "MMMM, D, YYYY"
            )}`}
        </div>
      </div>
      <div className="single-info-section info2">
        <h1 style={{ fontWeight: "bold" }}>{info.name}</h1>
      </div>
      <div className="single-info-section info2">
        <div className="question">Email</div>
        <div className="answer">{info.email}</div>
      </div>
      <div className="single-info-section info2">
        <div className="question">
          {
            "What organization is supporting you locally or what organization are you affiliated with? "
          }
        </div>
        <div className="answer">
          {info.organization ? info.organization : "No affiliation"}
        </div>
      </div>

      <div className="single-info-section info2">
        <div className="question">
          {
            "Let us know more about you. Check ALL of the boxes that apply. When filling out other, please be very specific."
          }
        </div>
        <div className="answer">{renderList(info?.immigrant_status, "• ")}</div>
      </div>
      <div className="single-info-section info2">
        <div className="question">{"Country"}</div>
        <div className="answer">{info.Country}</div>
      </div>
      <div className="single-info-section info2">
        <div className="question">
          {"Let us know more about you. How do you identify?"}
        </div>
        <div className="answer">{info.identify}</div>
      </div>
      <div className="single-info-section info2">
        <div className="question">{"Preferred Language(s)"}</div>
        <div className="answer">
          {Array.isArray(info.language)
            ? info.language.join(", ")
            : info.language}
        </div>
      </div>

      <div className="single-info-section info2">
        <div className="question">
          {
            "What special topics would you be interested in? If one is not on the list please add it in other:"
          }
        </div>
        <div className="answer">{renderList(info?.topics)}</div>
      </div>

      <div className="single-info-section info2">
        <div className="question">
          {
            "What do you currently do? Please check ALL the options that apply to you. If you select ''other'', please be specific"
          }
        </div>
        <div className="answer"> {renderList(info?.workstate)}</div>
      </div>

      <div className="single-info-section info2">
        <div className="question">
          {
            "	Would you be interested in being highlighted as one of our mentees on social media?"
          }
        </div>
        <div className="answer">{info.isSocial}</div>
      </div>

      <div className="single-info-section info2">
        <div className="question">{"Do you have any questions?"}</div>
        <div className="answer">{info.questions}</div>
      </div>
    </div>
  );
}

export default NewMentorAppInfo;
